import { render, staticRenderFns } from "./EventsPerTournamentModal.vue?vue&type=template&id=10f37140"
import script from "./EventsPerTournamentModal.vue?vue&type=script&lang=js"
export * from "./EventsPerTournamentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports